import { createReducer, on } from '@ngrx/store';

import {
  selectHotelDestinationPlaceAction, searchDestinationPlaceInfoSuccessAction
} from '@shared/base-search-bar/store/actions/search-bar.actions';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';
import {
  DestinationPlaceInfoResponse,
  HotelDestinationInfoType, HotelDestinationInputType, InputDestinationPlace
} from '@shared/base-search-bar/entities/autocomplete-destionation';

export const initialState: InputDestinationPlace = {} as InputDestinationPlace;

export const hotelDestinationPlaceReducer = createReducer(
  initialState,
  on(selectHotelDestinationPlaceAction, (state, { selection }) => {
    return selection;
  }),
  on(searchDestinationPlaceInfoSuccessAction, (state, { response }) => {
    if (state.InputType && state.Id) {
      if (state.Id !== response.Id) {
        return getState(response);
      } else return { ...state, NearestIata: response.NearestIata };
    } else return getState(response);
  }),
  on(loadSearchDataSuccessAction, (state, { data }) => data?.hotelDestinationPlace ? data.hotelDestinationPlace : initialState),
);

function getState(response: DestinationPlaceInfoResponse): InputDestinationPlace {
  const destination = {
    Id: response.Id,
    NearestIata: response.NearestIata
  };
  switch (response?.Type) {
    case HotelDestinationInfoType.HOTEL:
      return {
        ...destination,
        hotel_name: response.Name,
        InputType: HotelDestinationInputType.hotel
      };
    default:
      return {
        ...destination,
        Name: response.Name,
        InputType: HotelDestinationInputType.location
      };
  }
}
